import { takeLatest, takeEvery, select, call, put } from 'redux-saga/effects';
import { apiSaga } from '../../../sagas';
import { delay } from 'redux-saga';
import { updateRateSetsOrExtrasOrOffers as updateCommission } from './update-commission-rates';
import { updateRateSetsOrExtrasOrOffers as updateNett } from './update-nett-rates';
import updateDiscountRates from './update-discount-rates';

function* updateRates() {
  const state = yield select(mainState => mainState.contracting.massRateChange);
  const updateType = state.get('updateType');
  const rateType = state.get('rateType');
  const retailNettMeasure = state.getIn([updateType, `${rateType}Measure`]);
  const notApplyToExtraChild = state.getIn([updateType, `notApplyToExtraChildFor${rateType}`]);
  const roundingSetting = state.getIn([updateType, 'roundingSetting'])
    ? state.getIn([updateType, 'roundingSetting']).toJS()
    : { roundType: 'normal', cents: 1 };
  const settings = {
    updateType,
    retailNettMeasure,
    notApplyToExtraChild,
    roundingSetting,
  };

  const newState = state.updateIn([updateType, 'products'], products =>
    products.map(product => {
      if (rateType === 'discount') {
        return updateDiscountRates(settings, product);
      }
      const newNums = {
        updatedCommission: product.get('commission'),
        retailDiff: product.get('retailDiff'),
        nettDiff: product.get('nettDiff'),
      };
      const updateRateSetsOrExtrasOrOffers = (() => {
        if (rateType === 'commission') return updateCommission;
        if (rateType === 'nett') return updateNett;
      })();
      if (updateType === 'seasonRates') {
        return product.update('seasonRates', seasonRates => {
          if (!seasonRates) return seasonRates;
          return seasonRates.map(seasonRate =>
            seasonRate.updateIn(['rateSets', rateType], rateSets =>
              updateRateSetsOrExtrasOrOffers(
                newNums,
                settings,
                rateSets,
              ),
            ),
          );
        });
      }
      return product.updateIn([updateType, rateType], extrasOrOffers =>
        updateRateSetsOrExtrasOrOffers(
          newNums,
          settings,
          extrasOrOffers,
        ),
      );
    }),
  );
  yield put({
    type: 'UPDATE_MASS_RATE_CHANGE_CALCULATION',
    payload: newState,
  });
}

export default [
  takeLatest('CHANGE_WIDGET_VALUE_FOR_APPLY_ALL', updateRates),
  takeLatest('CHANGE_WIDGET_VALUE_FOR_PRODUCT', updateRates),
  takeLatest('CHANGE_MASS_RATE_CHANGE_MEASURE', updateRates),
  takeLatest('CHANGE_ROUNDING_SETTINGS_IN_MASS_RATE_CHANGE', updateRates),
  takeLatest('ON_CHANGE_NOT_APPLY_MASS_RATE_CHANGE_TO_EXTRA_CHILD', updateRates),
];



// WEBPACK FOOTER //
// ./src/app/stores/contracting/mass-rate-change/sagas.js